import React from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import Tooltip from '../../ViewWrapperContainer/ViewWrapper/ToolTip/ToolTip';
import './PlayButton.scss';

const PlayButton = ({
  playing,
  hovering,
  backgroundColor,
  color,
  onEnter,
  onLeave,
  handleClick,
  children,
  tier,
  tooltip,
  tooltipClass,
  isMobile,
  minimize,
}) => {
  const { t } = useTranslation();
  const active = hovering || playing;
  const classes = cx({ active: playing, minimize });
  const isStarter = cx({ starter: tier === 'starter' });
  const tooltipClasses = cx(tooltipClass, { minimize });
  return (
    <div className={`pano-ctrl-btn__play-btn-wrapper ${classes}`}>
      <button
        className={`pano-ctrl-btn play-btn ${classes} ${isStarter}`}
        data-cy="pano-ctrl-btn__play-btn"
        onClick={handleClick}
        onMouseEnter={onEnter}
        onMouseLeave={onLeave}
        aria-label={t(
          `publicTour.ada.playButton.${playing ? 'pause' : 'play'}`
        )}
        aria-pressed={playing}
      >
        <div
          className={`overlay ${classes}`}
          style={{
            color: active ? backgroundColor : color,
            backgroundColor: active ? color : backgroundColor,
          }}
        >
          {children}
        </div>
        {tooltip && (
          <Tooltip
            style={{ color: backgroundColor, backgroundColor: color }}
            show={!isMobile && hovering}
            tooltipClass={tooltipClasses}
            {...tooltip}
          />
        )}
      </button>
    </div>
  );
};

export default PlayButton;
